import React, { useEffect, useCallback } from 'react';
import Utils from '@/common/utils/utils';

const MermaidDiagram = ({ code, id }) => {
    const containerCallbackRef = useCallback(node => {
        if (node) {
            const parentDiv = node.closest('.mermaid-render');
            try {
                const mermaid = window.mermaid;
                if (!mermaid) {
                    console.error('Mermaid is not loaded yet.');
                    throw new Error('Mermaid is not available.');
                }
                mermaid.parse(code);

                // Render Mermaid diagram
                mermaid.render('graphDiv' + id, code, svgCode => {
                    node.innerHTML = svgCode;

                    if (parentDiv) {
                        parentDiv.classList.remove('mermaid-render-fail');
                        parentDiv.classList.add('mermaid-render-success');
                    }
                });
            } catch (err) {
                let escapeCode = Utils.escapeHtmlCharacters(code)
                node.innerHTML = `<div 
                    class="mermaid-text"
                    disable>${escapeCode}</div>`;
                if (parentDiv) {
                    parentDiv.classList.remove('mermaid-render-success');
                    parentDiv.classList.add('mermaid-render-fail');
                }
            }
        }
    }, [code]);

    return (
        <div className={'mermaid-render'}>
            <div ref={containerCallbackRef}></div>
        </div>
    );
};

export default MermaidDiagram;